// extracted by mini-css-extract-plugin
export default {"container":"progress_container__TxMLj","label":"progress_label__B2v7P","progress":"progress_progress__M9LGc","dot":"progress_dot__rIOYL","active":"progress_active__PlW-L"};